import { TableOption, TableSource } from '@tripointe/tripointe-cms/types';
import { TOOLTIPS_TEXTS } from './tooltips';

const contactTypesTableTooltips = TOOLTIPS_TEXTS.contactVendorsTable;

export const CONTACT_VENDORS_ACTIVE_OPTIONS: TableOption[] = [
  { action: 'edit', src: 'icons/green-edit' },
  { action: 'delete', src: 'icons/delete' },
  { action: 'mobileMenu', src: 'icons/more' }
];

export const CONTACT_VENDORS_ARCHIVED_OPTIONS: TableOption[] = [
  { action: 'unarchive', src: 'icons/unarchive' },
  { action: 'deleteArchive', src: 'icons/delete' },
  { action: 'mobileMenu', src: 'icons/more' }
];

export const CONTACT_VENDORS_TABLE_CONFIG: TableSource = {
  displayedColumns: ['name', 'state', 'options'],
  displayedTitles: ['Name', 'State / Province', 'Actions'],
  columnsConfig: [{ sorting: true }, { sorting: true }, { sorting: false }],
  displayedTooltips: [contactTypesTableTooltips.name, contactTypesTableTooltips.state],
  options: null,
  dataSource: []
};
